/** Query-параметр для открытия модалки редактирования правила. */
export const CRM_AUTOMATION_DEEP_LINK_PARAM = 'automation-id'

export const CRM_AUTOMATION_SETTINGS_PATH = '/crm-settings'
export const CRM_AUTOMATION_SETTINGS_TAB = '5'
export const CRM_AUTOMATION_RULES_SUBTAB = 'rules'

/** Ссылка на редактирование правила: `/crm-settings?tab=5&automation-tab=rules&automation-id=12` */
export const buildCrmAutomationEditUrl = (automationId: number): string => {
  const id = Math.trunc(Number(automationId))
  const params = new URLSearchParams({
    tab: CRM_AUTOMATION_SETTINGS_TAB,
    'automation-tab': CRM_AUTOMATION_RULES_SUBTAB,
  })
  if (Number.isFinite(id) && id > 0) {
    params.set(CRM_AUTOMATION_DEEP_LINK_PARAM, String(id))
  }
  return `${CRM_AUTOMATION_SETTINGS_PATH}?${params.toString()}`
}

export const parseCrmAutomationDeepLinkId = (
  value: string | null | undefined,
): number | null => {
  const id = Number(value)
  if (!Number.isFinite(id) || id <= 0) return null
  return Math.trunc(id)
}
